
<div hidden #i18nStrings>
	<!-- ################################ API RESPONSES & API ERRORS ################################ -->
	<span id="app.api.response.incorrect-username-password" i18n="API response when incorrectly signing in"
		>Incorrect Email address and/or Password</span
	>
	<span id="app.api.response.sign-in-error" i18n="the user sign in attempt was unsuccessful"
		>There was an error signing in to your account!</span
	>
	<span id="app.api.response.password-reset-request-success" i18n="success message after requesting password reset"
		>Success, you will receive an email containing a reset link.</span
	>
	<span
		id="app.api.response.password-reset-request-error"
		i18n="error message after requesting password reset failed@@passwordResetRequestError"
		>There was an error requesting your password reset.</span
	>
	<span
		id="app.api.response.password-reset-error"
		i18n="error message after attempting password reset failed@@passwordResetFailed"
		>There was an error resetting your password.</span
	>
	<span
		id="app.api.response.email-validate-error"
		i18n="error message after email validation failed@@emailValidationFailed"
		>There was an error validating your email.</span
	>
	<span
		id="app.api.response.email-validate-success"
		i18n="success message after email validation@@emailValidationSuccess"
		>Thank you, your email address has been validated.</span
	>
	<span
		id="app.api.response.creating-account-error"
		i18n="message telling user the account creation attempt was unsuccessful"
		>There was an error creating your free account!</span
	>
	<span id="app.api.response.sign-in-error" i18n="message telling user there was a problem signing into their account"
		>There was an error signing in to your account!</span
	>
	<span
		id="app.api.response.general-request-error"
		i18n="alert message telling user there was an error with the API connection"
		>Oops! Something went wrong.</span
	>
	<span
		id="app.api.response.general-session-expired"
		i18n="alert message telling user there was an error with the API connection"
		>Oops! Looks like your session has expired, please log in to try again.</span
	>
	<span
		id="app.api.response.sso-expired-session-error"
		i18n="alert message telling user the SSO login failed because expired session"
		>Oops! Looks like your session has expired, visit your service provider to try again.</span
	>
	<span id="app.api.response.not-valid-email" i18n="the entered email address is not valid">Not a valid email</span>
	<span id="app.api.response.failed-to-update-user" i18n="user details could not be updated">Failed to update the user record.</span>
	<span id="app.api.response.non-existing-user" i18n="the entered user email doe not exist in the system"
		>That user does not exist!</span
	>
	<span id="app.api.response.unverified-user" i18n="user's email is not validated">That email address is registered but has not yet been validated</span>
	<span id="app.api.response.contact-with-more-permissions" i18n="user's email is already a contact but with more permissions">Email is already registered as a contact with greater permissions than this role</span>

	<span
		id="app.api.response.event-hook-test-results"
		i18n="alert message telling user the response from Event Hook test"
	>Event Hook Test Response</span>

	<!-- ################################ DESCRIPTORS ################################  -->
	<span id="app.descriptor.accept" i18n="button title for accepting a dialog">Accept</span>
	<span id="app.descriptor.error" i18n="error dialog title">Error</span>
	<span id="app.descriptor.success" i18n="success dialog title">Success</span>
	<span id="app.descriptor.attention" i18n="attention dialog title">Attention</span>
	<span id="app.descriptor.warning" i18n="warning dialog title">Warning</span>
	<span id="app.descriptor.close" i18n="close prompt">Close</span>
	<span id="app.descriptor.cancel" i18n="cancel prompt">Cancel</span>
	<span id="app.descriptor.reset" i18n="reset prompt">Reset</span>
	<span id="app.descriptor.next" i18n="next prompt">Next</span>
	<span id="app.descriptor.previous" i18n="previous prompt">Previous</span>
	<span id="app.descriptor.dashboard" i18n="title for the Dashboard menu item">Dashboard</span>
	<span id="app.descriptor.users" i18n="title for the Users menu item">Users</span>
	<span id="app.descriptor.services" i18n="title for the Services menu item">Services</span>
	<span id="app.descriptor.companies" i18n="title for the Companies menu item">Companies</span>
    <span id="app.descriptor.appadmin" i18n="title for the App Admin menu item">App Admin</span>
	<span id="app.descriptor.support" i18n="title for the Support menu item">Support</span>
	<span id="app.descriptor.documentation" i18n="title for the Documentation menu item">Documentation</span>
	<span id="app.descriptor.pricing" i18n="title for the Pricing menu item">Pricing</span>
	<span id="app.descriptor.my-profile" i18n="title used for user's profile">My profile</span>
	<span id="app.descriptor.firstname" i18n="label for user's firstname input form">First name</span>
	<span id="app.descriptor.lastname" i18n="label for user's lastname input form">Last name</span>
	<span id="app.descriptor.email-address" i18n="label for user's email address input form">Email address</span>
	<span id="app.descriptor.locale" i18n="label for user's locale select form">Locale</span>
	<span id="app.descriptor.language" i18n="label for user's language select form">Language</span>
	<span id="app.descriptor.password" i18n="label to describe the password input field">Password</span>
	<span id="app.descriptor.fake-email" i18n="fake email address placeholder">jo@example.com</span>
	<span id="app.descriptor.authenticate" i18n="dialog title for re-authenticating password">Authenticate</span>
	<span id="app.descriptor.name" i18n>Name</span>
	<span id="app.descriptor.user" i18n>User</span>
	<span id="app.descriptor.date" i18n>Date</span>
	<span id="app.descriptor.not-set" i18n="when a value has not been supplied">Not set</span>
	<span id="app.descriptor.connections-image-url" i18n>Connections avatar image URL</span>
	<span id="app.descriptor.privacy-url" i18n>Privacy URL</span>
	<span id="app.descriptor.billing-contacts" i18n>Billing contacts</span>
	<span id="app.descriptor.billing-contact" i18n>Billing contact</span>
	<span id="app.descriptor.documentation-contacts" i18n>Documentation contacts</span>
	<span id="app.descriptor.documentation-contact" i18n>Documentation contact</span>
	<span id="app.descriptor.admin-contacts" i18n>Administrator contacts</span>
	<span id="app.descriptor.admin-contact" i18n>Administrator contact</span>
	<span id="app.descriptor.contacts" i18n>Contacts</span>
	<span id="app.descriptor.contact" i18n>Contact</span>
	<span id="app.descriptor.support-contact" i18n>Support contact</span>
	<span id="app.descriptor.terms-accepted" i18n>Accepted terms</span>
	<span id="app.descriptor.version" i18n>Version</span>
	<span id="app.descriptor.app-keys" i18n="security IDs">App Keys</span>
	<span id="app.descriptor.app-key" i18n="security ID">App Key</span>
	<span id="app.descriptor.cluster" i18n="a web-server object">Cluster</span>
	<span id="app.descriptor.pool-id" i18n="ID of a web-server object">Pool ID</span>
	<span id="app.descriptor.you" i18n="you as a person">You</span>
	<span id="app.descriptor.contact.add" i18n="add an additional contact">Add contact</span>
	<span id="app.descriptor.contact.admin.add" i18n="add an additional Administrator contact">Add administrator contact</span>
	<span id="app.descriptor.contact.documentation.add" i18n="add an additional Documentation contact">Add documentation contact</span>
	<span id="app.descriptor.contact.billing.add" i18n="add an additional Billing contact">Add billing contact</span>
	<span id="app.descriptor.contact.support.update" i18n="update the existing Support contact">Update support contact</span>

	<span id="app.descriptor.cluster.deploy.state.staging" i18n="deployment state of a server cluster">Staging</span>
	<span id="app.descriptor.cluster.deploy.state.production" i18n="deployment state of a server cluster">Production</span>

	<span id="app.descriptor.appkey.created" i18n="message success message when app key is created">The app key has been created.</span>
	<span id="app.descriptor.appkey.redirect-url" i18n="a URL to redirect too from within the OAuth flow">OAuth Redirect URL</span>
	<span id="app.descriptor.legal.zone5-cloud-legals" i18n="default document name for legal terms & conditions">Zone 5 Cloud Legals</span>
	<span id="app.descriptor.archived" i18n="state of a document">archived</span>
	<span id="app.descriptor.draft" i18n="state of a document">draft</span>
	<span id="app.descriptor.published" i18n="state of a document">published</span>
	<span id="app.descriptor.accepted-version" i18n="signed version of legal document">accepted version</span>
	<span id="app.descriptor.unsigned-version" i18n="version of legal document that needs accepting/signing">unsigned version</span>
	<span id="app.descriptor.active" i18n="state of a document being published and available">active</span>
	<span id="app.descriptor.publish" i18n="state of a document">publish</span>

	<span id="app.descriptor.public" i18n="if something is available to all">public</span>
	<span id="app.descriptor.private" i18n="if something has limited availability">private</span>

	<span id="app.descriptor.menu.users" i18n="menu item for link to users">Users</span>
	<span id="app.descriptor.menu.events" i18n="menu item for link to events">Events</span>
	<span id="app.descriptor.menu.companies-title" i18n="menu item title for link to companies">Back to Companies</span>

	<span id="app.descriptor.company.event-hooks.appkey-copy-settings" i18n="message success message for event hook settings transferred">The app key event hook settings has been cloned.</span>
	<span id="app.descriptor.company.event-hooks.created" i18n="message success message for event hook mapping created">The event hook(s) has been created.</span>
	<span id="app.descriptor.company.event-hooks.updated" i18n="message success message for event hook mapping updated">The event hook has been updated.</span>

	<span id="app.descriptor.company.legals.accepted" i18n="message success message for user accepting legals">Legals accepted.</span>

	<span id="app.descriptor.users.verification-email-sent" i18n="verification email sent to user">Successfully requested verification email.</span>
	<span id="app.descriptor.users.reset-password-email-sent" i18n="sent password reset request to user">Successfully requested a password reset.</span>
	<span id="app.descriptor.users.reset-password-email-send-failed" i18n="failed to send password reset request to user">Failed to request password reset.</span>
	<span id="app.descriptor.users.updated-cognito-groups" i18n="users cognito groups updated">Cognito groups updated.</span>
	<span id="app.descriptor.users.updated-user-attributes" i18n="user attributes updated">User attributes updated.</span>
	<span id="app.descriptor.users.updated-user-email" i18n="user email updated">User email updated.</span>
	<span id="app.descriptor.users.email-verified" i18n="user email has been verified">Email address verified.</span>
	<span id="app.descriptor.users.user-deleted" i18n="user email has been verified">User deleted.</span>
	<span id="app.descriptor.users.user-migrated" i18n="user account has been migrated">User migrated.</span>
	<span id="app.descriptor.users.user-not-migrated" i18n="user account has not been migrated">Failed to migrate user account.</span>
	<span id="app.descriptor.users.suspended" i18n="user account was suspended">User suspended.</span>
	<span id="app.descriptor.users.unsuspended" i18n="user account was unsuspended">User unsuspended.</span>
	<span id="app.descriptor.users.account-status-update-failed" i18n="failed to update users account status">Failed to update users account status.</span>

	<span id="app.descriptor.users.fields.uuid" i18n="UUID field name">UUID</span>
	<span id="app.descriptor.users.fields.email" i18n="Email field name">Email</span>
	<span id="app.descriptor.users.fields.clientId" i18n="Client ID field name">Client ID</span>
	<span id="app.descriptor.users.fields.lastname" i18n="Last name field name">Last Name</span>
	<span id="app.descriptor.users.fields.firstname" i18n="First name field name">First Name</span>
	<span id="app.descriptor.users.fields.state" i18n="Country state field name">State</span>
	<span id="app.descriptor.users.fields.locality" i18n="Country locality field name">Locality</span>
	<span id="app.descriptor.users.fields.country" i18n="Country field name">Country</span>
	<span id="app.descriptor.users.fields.timezone" i18n="Timezone field name">Timezone</span>
	<span id="app.descriptor.users.fields.locale" i18n="Locale field name">Locale</span>

	<!-- ################################ Branding ################################ -->
	<span id="app.branding.b2b-specialized.sso.copyright" i18n="site copyright text">&#169; 2001 - 2021 Specialized Bicycle Components. All rights reserved.</span>

	<!-- ################################ PROMPTS ################################ -->
	<span id="app.prompt.generic.confirm-save-message" i18n="generic confirm save changes messages">Are you sure you want to save the changes?</span>

	<span id="app.prompt.generic.delete.confirm-message" i18n="prompt user if they want to delete a choosen item">Are you sure?</span>
	<span id="app.prompt.please-enter-password" i18n="prompt user to enter their password">Please enter your password</span>
	<span id="app.prompt.form-field-is-required" i18n="this input field must contain character">This field is required</span>
	<span id="app.prompt.passwords-do-not-match" i18n="the entered passwords do not match">Passwords do not match</span>
	<span id="app.prompt.numerical" i18n="the entered value is not numerical">The value must be numeric</span>
	<span id="app.prompt.app-name-is-invalid" i18n="entered app name can only contain alphanumeric characters and spaces">Name can only contain alphanumeric characters, periods, hyphens, underscores and spaces.</span>
	<span id="app.prompt.phone-is-invalid" i18n="entered phone number is not formatted correctly">Phone number formatted incorrectly, example: +61123456789</span>
	<span id="app.prompt.min-value" i18n="value smaller than min value">cannot be less than</span>
	<span id="app.prompt.already-registered" i18n="message telling that the entered email is already register"
		>Already registered</span
	>
	<span id="app.prompt.password-requirements" i18n="the requirements for a successful password"
		>minimum 8, a mix of uppercase, lowercase and number characters</span
	>
	<span id="app.prompt.email-not-validated" i18n="the email address is not validated">We have sent you an email containing a validation link to verify your email address.</span>
	<span id="app.prompt.remember-me" i18n="checkbox, asking user if they want to store a few of their details"
		>Remember me (not recommended on public computers)</span
	>
	<span id="app.prompt.session-expired" i18n="dialog title: secure login session has expired">Session expired</span>\

	<span id="app.prompt.pending-changes-confirm-message" i18n="message to inform user that changes will be lost when performing the action">You have unsaved changes that will be lost. Are you sure you want to continue?</span>

	<span id="app.prompt.account.delete.confirm-message" i18n="message to user asking if they really want to delete the user account"
		>Are you sure you want to delete the account?</span>
	<span id="app.prompt.account.delete.blocked-has-associations" i18n="if user is trying to delete their account but it has blocking content or associations that break if deleted"
		>We cannot delete this account. This account has connections and/or associations in one or more companies.</span>
	<span id="app.prompt.company.delete.confirm-message" i18n="message to user asking if they really want to delete the company"
		>Are you sure you want to delete this company?</span>
	<span id="app.prompt.company.delete.blocked-has-keys" i18n="if user is trying to delete a company and it still has associated API keys"
		>We cannot delete this company, as it has associated app keys. To continue, first delete all app keys associated with the company.</span>

	<span id="app.prompt.guard.access-denied" i18n="message telling user they don't have access"
		>Access to this resource is restricted to certain roles. Please contact your company Admin to be added to either of these roles: </span>

	<span id="app.prompt.contact.delete.confirm-message" i18n="message to user asking if they really want to remove the contact from the list"
		>Are you sure you want to remove this contact?</span>
	<span id="app.prompt.contact.delete.error" i18n="error while trying to remove a contact from a list"
		>There was an error trying to remove the contact.</span>

	<span id="app.prompt.contact.delete.admin.me.conmfirm-message" i18n="tell the user that if they remove themselves from the admin contacts they will no longer be able to edit the associated company"
		>Removing yourself from the administration contacts means you will no longer have any company editing rights!</span>

	<span id="app.prompt.appkey.copy-event-hook" i18n="message asking user if they really want to copy and overwrite event hook settings">This will replace the app key event settings and will affect any applications relying on this key. Are you sure you want to continue?</span>
	<span id="app.prompt.appkey.configure-event-hooks" i18n="message asking user if they really want to overwrite event hook settings">Updating existing event hook mappings will affect any application relying on these events. Are you sure you want to continue?</span>
	<span id="app.prompt.appkey.delete-event-hook" i18n="message asking user if they really want to delete the event hook mapping">Deleting this will affect any application relying on this event. Are you sure you want to continue?</span>
	<span id="app.prompt.appkey.update-event-hook" i18n="message asking user if they really want to update the event hook mapping">Updating this will affect any application relying on this event. Are you sure you want to continue?</span>
	<span id="app.prompt.appkey.delete.confirm-message" i18n="message to user asking if they really want to delete this application key"
		>Suspending the application key will revoke system access of any app using this key. This can only be undone by a SYSTEM ADMIN. Are you sure you want to continue?</span>
	<span id="app.prompt.appkey.confirm-save" i18n="message to user asking if they really want to save changes to this application key"
		>Updating these settings will affect any application using the key, are you sure you want to continue?</span>

	<span id="app.prompt.legal.term-updated" i18n="message confirming the legal document update">The document has been updated.</span>
	<span id="app.prompt.legal.app-keys-associated" i18n="message confirming the app keys has been associated with the legal document">App keys associated with legal.</span>
	<span id="app.prompt.legal.accept-terms" i18n="message asking the user if the have veiwed and accept the legal document">I have viewed and accept any terms, conditions, and announcements that are described in this document.</span>
	<span id="app.prompt.legal.disassociate-terms" i18n="message asking the user if he wants to disassociate the legal with the app key">This will disassociate the legal document from the app key. Are you sure you want to continue?</span>
	<span id="app.prompt.legal.associate-terms" i18n="message asking the user if he wants to associate the legal with the app keys">This will associate the legal document with the selected app keys. Are you sure you want to continue?</span>
	<span id="app.prompt.legal.associate-to-app-key" i18n="message asking the user if he wants to associate the legals with the app key">This will associate the selected legal documents with the app key. Are you sure you want to continue?</span>
	<span id="app.prompt.legal.open-external-document" i18n="message to user warning that this will open up a link to an external document">This document is not hosted by Zone5, following this link opens a new browser tab and redirects to an external URL. Are you sure you want to continue?</span>

	<span id="app.prompt.new-legal-document" i18n>New legal document</span>

	<span id="app.prompt.publish-document" i18n>Publish this document and make it available to your customers?</span>
	<span id="app.prompt.delete-document" i18n>Are you sure you want to delete this document?</span>

	<span id="app.prompt.users.app-key-select.search" i18n="prompt to select a key before search can be performed">To perform a search, select an app key to continue.</span>
	<span id="app.prompt.users.app-key-unauthorized" i18n="selected app key is not authorized to perform action">The selected app key is not authorized to perform this action. Select another key and try again.</span>

	<span id="app.prompt.users.accepted-user-terms" i18n="message confirming that you have accepted terms for a user">Terms successfully accepted.</span>
	<span id="app.prompt.users.failed-accept-user-terms" i18n="message confirming failed to accept terms for a user">Failed to accept terms on behalf of the user.</span>
	<span id="app.prompt.users.confirm-accept-user-terms" i18n="message confirming that you accept these terms for a user">Accepting terms on behalf of a user circumvents any protection that would otherwise force a user to accept terms and conditions. Are you sure you want to continue?</span>
	<span id="app.prompt.users.confirm-revoke-user-terms-acceptance" i18n="message confirming that revoke the terms acceptance for a user">Revoking acceptance of terms will force users to re-accept any terms and conditions before they can continue. Are you sure you want to continue?</span>
	<span id="app.prompt.users.manual-password-reset.confirm-message" i18n>Are you sure you want to change the users password?</span>
	<span id="app.prompt.users.send-password-reset-email.confirm-message" i18n>This will send the user a request to reset their password. Are you sure you want to continue?</span>
	<span id="app.prompt.users.verify-email.confirm-message" i18n>Are you sure you want to manually verify this email address?</span>
	<span id="app.prompt.users.delete.confirm-message" i18n>Are you sure you want to delete this user?</span>
	<span id="app.prompt.users.migrate.confirm-message" i18n>Are you sure you want to migrate this user?</span>
	<span id="app.prompt.users.invalidate-email.confirm-message" i18n>Are you sure you want to manually invalidate this email?</span>
	<span id="app.prompt.users.update-cognito-groups.confirm-message" i18n>You are about to change the user's roles which will affect their API access. Are you sure you want to continue?</span>
	<span id="app.prompt.users.edit-user-attributes.confirm-message" i18n>Are you sure you want to continue?</span>
	<span id="app.prompt.users.edit-user-email.confirm-message" i18n>Warning! Changing the user's email address automatically validates the provided address. If you have entered an incorrect address you could lock the user out of their account. Are you sure you want to continue?</span>
	<span id="app.prompt.users.send-verification-email.confirm-message" i18n>Are you sure you want to continue?</span>
	<span id="app.prompt.users.suspend-toggle.confirm-suspend-message" i18n>Are you sure you want to suspend the account?</span>
	<span id="app.prompt.users.suspend-toggle.confirm-unsuspend-message" i18n>Are you sure you want to unsuspend the account?</span>

	<span id="app.prompt.email-exists" i18n>this email has already registered</span>

	<!-- ################################ CTA ################################  -->
	<span id="app.cta.return" i18n="prompt to return">Return</span>

	<!-- ################################ ACTIONS ################################  -->
	<span id="app.action.validating-email" i18n="the server is validating the user's email address">Validating email</span>
	<span id="app.action.validating-url" i18n="the server is validating the a URL address">Validating URL</span>
	<span id="app.action.copied-to-clipboard" i18n="content has been copied to users clipboard">Copied to clipboard</span>
	<span id="app.action.event-hook-copy" i18n="content has been copied to create new eventhook form">Content copied, select a event hook to continue.</span>

	<span id="app.api.response.not-valid-url" i18n="the supplied URL address is not valid">Invalid URL</span>
	<span id="app.api.response.not-reachable-url" i18n="the supplied URL address cannot be loaded">Cannot load this URL</span>
	<span id="app.prompt.form-field-is-required" i18n="the form inpout fields is required">This field is required</span>

	<span id="app.form.input.version.invalid" i18n="the version string entered is not valid">That version string is not valid (i.e. 1.02 is valid)</span>
	<span id="app.form.input.version.must-be-higher" i18n="the version string entered must be higher that this">New versions must be a higher number</span>
	<span id="app.form.input.version.locale-already-exists" i18n="user is trying to upload a legal document for a language that already exists">You cannot upload unless you increment the version, note that incrementing the version will invalidate previous revisions as soon as the file is published.</span>

	<!-- ################################ MESSAGES ################################  -->
	<span
		id="app.message.check-email-for-validation-link"
		i18n="alert message to tell the user to click the validate link in the welcome email message"
		>Please check your email messages and click the 'Validate my email' link</span
	>
	<span id="app.message.new-legals-to-sign" i18n>There are new legal documents available to view, download and accept.</span>
	<span id="app.message.new-cluster-legals-to-sign" i18n>There are new legal documents available for the selected cluster. These need to reviewed and accepted before new keys can be generated.</span>

	<!-- ################################ STATICS ################################ -->
	<span id="app.units.kg" i18n="units|Shorthand for kilograms as a unit of measurement">kg</span>
	<span id="app.units.lb" i18n="units|Shorthand for pounds as a unit of measurement">lb</span>
	<span id="app.units.cm" i18n="units|Shorthand for centimetres as a unit of measurement">cm</span>
	<span id="app.units.m" i18n="units|Shorthand for metres as a unit of measurement">m</span>
	<span id="app.units.ft" i18n="units|Shorthand for foot as a unit of measurement">ft</span>
	<span id="app.units.km" i18n="units|Shorthand for kilometres as a unit of measurement">km</span>
	<span id="app.units.mi" i18n="units|Shorthand for miles as a unit of measurement">mi</span>

	<span id="app.units.kmh" i18n="units|Shorthand for kilometres per hour as a unit of measurement">km/h</span>
	<span id="app.units.mih" i18n="units|Shorthand for miles per hour as a unit of measurement">mi/h</span>

	<span id="app.unit.metric" i18n="units|metric unit system">Metric</span>
	<span id="app.unit.imperial" i18n="units|imperial unit system">Imperial</span>

	<span id="app.gender.male" i18n="gender|male">Male</span>
	<span id="app.gender.female" i18n="gender|female">Female</span>
	<span id="app.gender.other" i18n="gender|other">Other</span>
	<span id="app.gender.notsay" i18n="gender|notsay">Prefer not to say</span>

	<span id="app.countryCode.ad" i18n="country code">Andorra</span>
	<span id="app.countryCode.ae" i18n="country code">United Arab Emirates</span>
	<span id="app.countryCode.af" i18n="country code">Afghanistan</span>
	<span id="app.countryCode.ag" i18n="country code">Antigua and Barbuda</span>
	<span id="app.countryCode.ai" i18n="country code">Anguilla</span>
	<span id="app.countryCode.al" i18n="country code">Albania</span>
	<span id="app.countryCode.am" i18n="country code">Armenia</span>
	<span id="app.countryCode.an" i18n="country code">Netherlands Antilles</span>
	<span id="app.countryCode.ao" i18n="country code">Angola</span>
	<span id="app.countryCode.aq" i18n="country code">Antarctica</span>
	<span id="app.countryCode.ar" i18n="country code">Argentina</span>
	<span id="app.countryCode.as" i18n="country code">American Samoa</span>
	<span id="app.countryCode.at" i18n="country code">Austria</span>
	<span id="app.countryCode.au" i18n="country code">Australia</span>
	<span id="app.countryCode.aw" i18n="country code">Aruba</span>
	<span id="app.countryCode.az" i18n="country code">Azerbaijan</span>
	<span id="app.countryCode.ba" i18n="country code">Bosnia and Herzegovina</span>
	<span id="app.countryCode.bb" i18n="country code">Barbados</span>
	<span id="app.countryCode.bd" i18n="country code">Bangladesh</span>
	<span id="app.countryCode.be" i18n="country code">Belgium</span>
	<span id="app.countryCode.bf" i18n="country code">Burkina Faso</span>
	<span id="app.countryCode.bg" i18n="country code">Bulgaria</span>
	<span id="app.countryCode.bh" i18n="country code">Bahrain</span>
	<span id="app.countryCode.bi" i18n="country code">Burundi</span>
	<span id="app.countryCode.bj" i18n="country code">Benin</span>
	<span id="app.countryCode.bm" i18n="country code">Bermuda</span>
	<span id="app.countryCode.bn" i18n="country code">Brunei</span>
	<span id="app.countryCode.bo" i18n="country code">Bolivia</span>
	<span id="app.countryCode.br" i18n="country code">Brazil</span>
	<span id="app.countryCode.bs" i18n="country code">Bahamas</span>
	<span id="app.countryCode.bt" i18n="country code">Bhutan</span>
	<span id="app.countryCode.bw" i18n="country code">Botswana</span>
	<span id="app.countryCode.by" i18n="country code">Belarus</span>
	<span id="app.countryCode.bz" i18n="country code">Belize</span>
	<span id="app.countryCode.ca" i18n="country code">Canada</span>
	<span id="app.countryCode.cc" i18n="country code">Cocos Islands</span>
	<span id="app.countryCode.cd" i18n="country code">The Democratic Republic Of Congo</span>
	<span id="app.countryCode.cf" i18n="country code">Central African Republic</span>
	<span id="app.countryCode.cg" i18n="country code">Congo</span>
	<span id="app.countryCode.ch" i18n="country code">Switzerland</span>
	<span id="app.countryCode.ci" i18n="country code">Côte d'Ivoire</span>
	<span id="app.countryCode.ck" i18n="country code">Cook Islands</span>
	<span id="app.countryCode.cl" i18n="country code">Chile</span>
	<span id="app.countryCode.cm" i18n="country code">Cameroon</span>
	<span id="app.countryCode.cn" i18n="country code">China</span>
	<span id="app.countryCode.co" i18n="country code">Colombia</span>
	<span id="app.countryCode.cr" i18n="country code">Costa Rica</span>
	<span id="app.countryCode.cu" i18n="country code">Cuba</span>
	<span id="app.countryCode.cv" i18n="country code">Cape Verde</span>
	<span id="app.countryCode.cx" i18n="country code">Christmas Island</span>
	<span id="app.countryCode.cy" i18n="country code">Cyprus</span>
	<span id="app.countryCode.cz" i18n="country code">Czech Republic</span>
	<span id="app.countryCode.de" i18n="country code">Germany</span>
	<span id="app.countryCode.dj" i18n="country code">Djibouti</span>
	<span id="app.countryCode.dk" i18n="country code">Denmark</span>
	<span id="app.countryCode.dm" i18n="country code">Dominica</span>
	<span id="app.countryCode.do" i18n="country code">Dominican Republic</span>
	<span id="app.countryCode.dz" i18n="country code">Algeria</span>
	<span id="app.countryCode.ec" i18n="country code">Ecuador</span>
	<span id="app.countryCode.ee" i18n="country code">Estonia</span>
	<span id="app.countryCode.eg" i18n="country code">Egypt</span>
	<span id="app.countryCode.eh" i18n="country code">Western Sahara</span>
	<span id="app.countryCode.er" i18n="country code">Eritrea</span>
	<span id="app.countryCode.es" i18n="country code">Spain</span>
	<span id="app.countryCode.et" i18n="country code">Ethiopia</span>
	<span id="app.countryCode.fi" i18n="country code">Finland</span>
	<span id="app.countryCode.fj" i18n="country code">Fiji</span>
	<span id="app.countryCode.fk" i18n="country code">Falkland Islands</span>
	<span id="app.countryCode.fm" i18n="country code">Micronesia</span>
	<span id="app.countryCode.fo" i18n="country code">Faroe Islands</span>
	<span id="app.countryCode.fr" i18n="country code">France</span>
	<span id="app.countryCode.ga" i18n="country code">Gabon</span>
	<span id="app.countryCode.gb" i18n="country code">United Kingdom</span>
	<span id="app.countryCode.gd" i18n="country code">Grenada</span>
	<span id="app.countryCode.ge" i18n="country code">Georgia</span>
	<span id="app.countryCode.gf" i18n="country code">French Guiana</span>
	<span id="app.countryCode.gh" i18n="country code">Ghana</span>
	<span id="app.countryCode.gi" i18n="country code">Gibraltar</span>
	<span id="app.countryCode.gl" i18n="country code">Greenland</span>
	<span id="app.countryCode.gm" i18n="country code">Gambia</span>
	<span id="app.countryCode.gn" i18n="country code">Guinea</span>
	<span id="app.countryCode.gp" i18n="country code">Guadeloupe</span>
	<span id="app.countryCode.gq" i18n="country code">Equatorial Guinea</span>
	<span id="app.countryCode.gr" i18n="country code">Greece</span>
	<span id="app.countryCode.gs" i18n="country code">South Georgia And The South Sandwich Islands</span>
	<span id="app.countryCode.gt" i18n="country code">Guatemala</span>
	<span id="app.countryCode.gu" i18n="country code">Guam</span>
	<span id="app.countryCode.gw" i18n="country code">Guinea-Bissau</span>
	<span id="app.countryCode.gy" i18n="country code">Guyana</span>
	<span id="app.countryCode.hk" i18n="country code">Hong Kong</span>
	<span id="app.countryCode.hn" i18n="country code">Honduras</span>
	<span id="app.countryCode.hr" i18n="country code">Croatia</span>
	<span id="app.countryCode.ht" i18n="country code">Haiti</span>
	<span id="app.countryCode.hu" i18n="country code">Hungary</span>
	<span id="app.countryCode.id" i18n="country code">Indonesia</span>
	<span id="app.countryCode.ie" i18n="country code">Ireland</span>
	<span id="app.countryCode.il" i18n="country code">Israel</span>
	<span id="app.countryCode.in" i18n="country code">India</span>
	<span id="app.countryCode.io" i18n="country code">British Indian Ocean Territory</span>
	<span id="app.countryCode.iq" i18n="country code">Iraq</span>
	<span id="app.countryCode.ir" i18n="country code">Iran</span>
	<span id="app.countryCode.is" i18n="country code">Iceland</span>
	<span id="app.countryCode.it" i18n="country code">Italy</span>
	<span id="app.countryCode.jm" i18n="country code">Jamaica</span>
	<span id="app.countryCode.jo" i18n="country code">Jordan</span>
	<span id="app.countryCode.jp" i18n="country code">Japan</span>
	<span id="app.countryCode.ke" i18n="country code">Kenya</span>
	<span id="app.countryCode.kg" i18n="country code">Kyrgyzstan</span>
	<span id="app.countryCode.kh" i18n="country code">Cambodia</span>
	<span id="app.countryCode.ki" i18n="country code">Kiribati</span>
	<span id="app.countryCode.km" i18n="country code">Comoros</span>
	<span id="app.countryCode.kn" i18n="country code">Saint Kitts And Nevis</span>
	<span id="app.countryCode.kp" i18n="country code">North Korea</span>
	<span id="app.countryCode.kr" i18n="country code">South Korea</span>
	<span id="app.countryCode.kw" i18n="country code">Kuwait</span>
	<span id="app.countryCode.ky" i18n="country code">Cayman Islands</span>
	<span id="app.countryCode.kz" i18n="country code">Kazakhstan</span>
	<span id="app.countryCode.la" i18n="country code">Laos</span>
	<span id="app.countryCode.lb" i18n="country code">Lebanon</span>
	<span id="app.countryCode.lc" i18n="country code">Saint Lucia</span>
	<span id="app.countryCode.li" i18n="country code">Liechtenstein</span>
	<span id="app.countryCode.lk" i18n="country code">Sri Lanka</span>
	<span id="app.countryCode.lr" i18n="country code">Liberia</span>
	<span id="app.countryCode.ls" i18n="country code">Lesotho</span>
	<span id="app.countryCode.lt" i18n="country code">Lithuania</span>
	<span id="app.countryCode.lu" i18n="country code">Luxembourg</span>
	<span id="app.countryCode.lv" i18n="country code">Latvia</span>
	<span id="app.countryCode.ly" i18n="country code">Libya</span>
	<span id="app.countryCode.ma" i18n="country code">Morocco</span>
	<span id="app.countryCode.mc" i18n="country code">Monaco</span>
	<span id="app.countryCode.md" i18n="country code">Moldova</span>
	<span id="app.countryCode.mg" i18n="country code">Madagascar</span>
	<span id="app.countryCode.mh" i18n="country code">Marshall Islands</span>
	<span id="app.countryCode.mk" i18n="country code">Macedonia</span>
	<span id="app.countryCode.ml" i18n="country code">Mali</span>
	<span id="app.countryCode.mm" i18n="country code">Myanmar</span>
	<span id="app.countryCode.mn" i18n="country code">Mongolia</span>
	<span id="app.countryCode.mo" i18n="country code">Macao</span>
	<span id="app.countryCode.mp" i18n="country code">Northern Mariana Islands</span>
	<span id="app.countryCode.mq" i18n="country code">Martinique</span>
	<span id="app.countryCode.mr" i18n="country code">Mauritania</span>
	<span id="app.countryCode.ms" i18n="country code">Montserrat</span>
	<span id="app.countryCode.mt" i18n="country code">Malta</span>
	<span id="app.countryCode.mu" i18n="country code">Mauritius</span>
	<span id="app.countryCode.mv" i18n="country code">Maldives</span>
	<span id="app.countryCode.mw" i18n="country code">Malawi</span>
	<span id="app.countryCode.mx" i18n="country code">Mexico</span>
	<span id="app.countryCode.my" i18n="country code">Malaysia</span>
	<span id="app.countryCode.mz" i18n="country code">Mozambique</span>
	<span id="app.countryCode.na" i18n="country code">Namibia</span>
	<span id="app.countryCode.nc" i18n="country code">New Caledonia</span>
	<span id="app.countryCode.ne" i18n="country code">Niger</span>
	<span id="app.countryCode.nf" i18n="country code">Norfolk Island</span>
	<span id="app.countryCode.ng" i18n="country code">Nigeria</span>
	<span id="app.countryCode.ni" i18n="country code">Nicaragua</span>
	<span id="app.countryCode.nl" i18n="country code">Netherlands</span>
	<span id="app.countryCode.no" i18n="country code">Norway</span>
	<span id="app.countryCode.np" i18n="country code">Nepal</span>
	<span id="app.countryCode.nr" i18n="country code">Nauru</span>
	<span id="app.countryCode.nu" i18n="country code">Niue</span>
	<span id="app.countryCode.nz" i18n="country code">New Zealand</span>
	<span id="app.countryCode.om" i18n="country code">Oman</span>
	<span id="app.countryCode.pa" i18n="country code">Panama</span>
	<span id="app.countryCode.pe" i18n="country code">Peru</span>
	<span id="app.countryCode.pf" i18n="country code">French Polynesia</span>
	<span id="app.countryCode.pg" i18n="country code">Papua New Guinea</span>
	<span id="app.countryCode.ph" i18n="country code">Philippines</span>
	<span id="app.countryCode.pk" i18n="country code">Pakistan</span>
	<span id="app.countryCode.pl" i18n="country code">Poland</span>
	<span id="app.countryCode.pm" i18n="country code">Saint Pierre And Miquelon</span>
	<span id="app.countryCode.pn" i18n="country code">Pitcairn</span>
	<span id="app.countryCode.pr" i18n="country code">Puerto Rico</span>
	<span id="app.countryCode.ps" i18n="country code">Palestine</span>
	<span id="app.countryCode.pt" i18n="country code">Portugal</span>
	<span id="app.countryCode.pw" i18n="country code">Palau</span>
	<span id="app.countryCode.py" i18n="country code">Paraguay</span>
	<span id="app.countryCode.qa" i18n="country code">Qatar</span>
	<span id="app.countryCode.re" i18n="country code">Reunion</span>
	<span id="app.countryCode.ro" i18n="country code">Romania</span>
	<span id="app.countryCode.ru" i18n="country code">Russia</span>
	<span id="app.countryCode.rw" i18n="country code">Rwanda</span>
	<span id="app.countryCode.sa" i18n="country code">Saudi Arabia</span>
	<span id="app.countryCode.sb" i18n="country code">Solomon Islands</span>
	<span id="app.countryCode.sc" i18n="country code">Seychelles</span>
	<span id="app.countryCode.sd" i18n="country code">Sudan</span>
	<span id="app.countryCode.se" i18n="country code">Sweden</span>
	<span id="app.countryCode.sg" i18n="country code">Singapore</span>
	<span id="app.countryCode.sh" i18n="country code">Saint Helena</span>
	<span id="app.countryCode.si" i18n="country code">Slovenia</span>
	<span id="app.countryCode.sj" i18n="country code">Svalbard And Jan Mayen</span>
	<span id="app.countryCode.sk" i18n="country code">Slovakia</span>
	<span id="app.countryCode.sl" i18n="country code">Sierra Leone</span>
	<span id="app.countryCode.sm" i18n="country code">San Marino</span>
	<span id="app.countryCode.sn" i18n="country code">Senegal</span>
	<span id="app.countryCode.so" i18n="country code">Somalia</span>
	<span id="app.countryCode.sr" i18n="country code">Suriname</span>
	<span id="app.countryCode.st" i18n="country code">Sao Tome And Principe</span>
	<span id="app.countryCode.sv" i18n="country code">El Salvador</span>
	<span id="app.countryCode.sy" i18n="country code">Syria</span>
	<span id="app.countryCode.sz" i18n="country code">Swaziland</span>
	<span id="app.countryCode.tc" i18n="country code">Turks And Caicos Islands</span>
	<span id="app.countryCode.td" i18n="country code">Chad</span>
	<span id="app.countryCode.tf" i18n="country code">French Southern Territories</span>
	<span id="app.countryCode.tg" i18n="country code">Togo</span>
	<span id="app.countryCode.th" i18n="country code">Thailand</span>
	<span id="app.countryCode.tj" i18n="country code">Tajikistan</span>
	<span id="app.countryCode.tk" i18n="country code">Tokelau</span>
	<span id="app.countryCode.tl" i18n="country code">Timor-Leste</span>
	<span id="app.countryCode.tm" i18n="country code">Turkmenistan</span>
	<span id="app.countryCode.tn" i18n="country code">Tunisia</span>
	<span id="app.countryCode.to" i18n="country code">Tonga</span>
	<span id="app.countryCode.tr" i18n="country code">Turkey</span>
	<span id="app.countryCode.tt" i18n="country code">Trinidad and Tobago</span>
	<span id="app.countryCode.tv" i18n="country code">Tuvalu</span>
	<span id="app.countryCode.tw" i18n="country code">Taiwan</span>
	<span id="app.countryCode.tz" i18n="country code">Tanzania</span>
	<span id="app.countryCode.ua" i18n="country code">Ukraine</span>
	<span id="app.countryCode.ug" i18n="country code">Uganda</span>
	<span id="app.countryCode.um" i18n="country code">United States Minor Outlying Islands</span>
	<span id="app.countryCode.us" i18n="country code">United States</span>
	<span id="app.countryCode.uy" i18n="country code">Uruguay</span>
	<span id="app.countryCode.uz" i18n="country code">Uzbekistan</span>
	<span id="app.countryCode.va" i18n="country code">Vatican</span>
	<span id="app.countryCode.vc" i18n="country code">Saint Vincent And The Grenadines</span>
	<span id="app.countryCode.ve" i18n="country code">Venezuela</span>
	<span id="app.countryCode.vg" i18n="country code">British Virgin Islands</span>
	<span id="app.countryCode.vi" i18n="country code">U.S. Virgin Islands</span>
	<span id="app.countryCode.vn" i18n="country code">Vietnam</span>
	<span id="app.countryCode.vu" i18n="country code">Vanuatu</span>
	<span id="app.countryCode.wf" i18n="country code">Wallis And Futuna</span>
	<span id="app.countryCode.ws" i18n="country code">Samoa</span>
	<span id="app.countryCode.ye" i18n="country code">Yemen</span>
	<span id="app.countryCode.yt" i18n="country code">Mayotte</span>
	<span id="app.countryCode.za" i18n="country code">South Africa</span>
	<span id="app.countryCode.zm" i18n="country code">Zambia</span>
	<span id="app.countryCode.zw" i18n="country code">Zimbabwe</span>
	<span id="app.countryCode.me" i18n="country code">Montenegro</span>
	<span id="app.countryCode.rs" i18n="country code">Serbia</span>
	<span id="app.countryCode.je" i18n="country code">Jersey</span>
	<span id="app.countryCode.bq" i18n="country code">Bonaire, Sint Eustatius and Saba</span>
	<span id="app.countryCode.im" i18n="country code">Isle Of Man</span>
	<span id="app.countryCode.ax" i18n="country code">Åland Islands</span>
	<span id="app.countryCode.bv" i18n="country code">Bouvet Island</span>
	<span id="app.countryCode.cw" i18n="country code">Curaçao</span>
	<span id="app.countryCode.gg" i18n="country code">Guernsey</span>
	<span id="app.countryCode.hm" i18n="country code">Heard Island And McDonald Islands</span>
	<span id="app.countryCode.bl" i18n="country code">Saint Barthélemy</span>
	<span id="app.countryCode.mf" i18n="country code">Saint Martin</span>
	<span id="app.countryCode.sx" i18n="country code">Saint Maarten (Dutch part)</span>
	<span id="app.countryCode.ss" i18n="country code">South Sudan</span>
</div>
